import { enableProdMode, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';
import { provideServiceWorker } from '@angular/service-worker';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers, provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
          })]})
    .catch((err) => {
        if (!environment.production) {
            console.error('Application bootstrap error:', err);
        } else {
            console.error('Application failed to start. Please try again later.');
        }
    });
